<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">Commodities</h4>
                                <h6 class="card-subtitle">List of commodities available in your marketplace.</h6>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link :to="{name: 'newcommodity'}"
                                                     class="btn btn-success waves-effect waves-light">
                                            <i class="fas fa-plus"></i> New Commodity
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body card-blue collapse show">
                        <div class="form-row">
                            <div class="form-group col-md-2">
                                <multiselect :clear-on-select="false"
                                             :close-on-select="true"
                                             :hide-selected="true"
                                             :internal-search="false"
                                             :options="categories"
                                             @search-change="filterCategory"
                                             class="form-control multiselect-sm"
                                             id="category"
                                             placeholder="Search Category"
                                             v-model="category">
                                    <template slot="singleLabel" slot-scope="props">
                                        <div class="option__desc">
                                            <div class="option__desc">
                                                {{ props.option.name }}
                                            </div>
                                        </div>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div class="option__desc">
                                            <h5>{{ props.option.name }}</h5>
                                        </div>
                                    </template>
                                </multiselect>
                            </div>

                            <div class="form-group col-md-4">
                                <input class="form-control" placeholder="Search by Name/Code/Variety/Native Name"
                                       type="text"
                                       v-model="search">
                            </div>

                            <div class="form-group col-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"
                                              id="basic-addon1">{{currentOrg.currency_symbol}}</span>
                                    </div>
                                    <input class="form-control" placeholder="Rate" type="number" v-model="rate">
                                    <select class="form-control input-append" style="max-width: 60px;" type="number"
                                            v-model="comp">
                                        <option value="=">=</option>
                                        <option value=">">&gt;</option>
                                        <option value="<">&lt;</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group col-md-2">
                                <div class="btn-group">
                                    <button @click="getCommodities(1)"
                                            class="btn btn-light btn-outline-success font-weight-bold"
                                            type="button">
                                        <i class="fa fa-search"/> Go!
                                    </button>
                                    <button @click="reset()"
                                            class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold"
                                            type="button">
                                        <i class="fa fa-undo"/> Reset
                                    </button>
                                </div>
                            </div>

                            <div class="col-1 text-right">
                                <span class="fa-xs fa-stack fa-1x ml-auto text-muted" title="Exporting, please wait ..."
                                      v-if="exporting">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                                <button aria-expanded="false" aria-haspopup="true"
                                        class="btn waves-effect waves-light btn-outline-info"
                                        data-toggle="dropdown" title="Operations">
                                    <i class="fa fa-grip-vertical"/>
                                </button>
                                <div class="dropdown-menu">
                                    <a @click="exportGSAsExcel()" class="dropdown-item" href="javascript:void(0)">
                                        <i class="fa fa-file-excel"/> Export
                                    </a>
                                    <input @change="handleRateUpload" accept=".xlsx" class="d-none" id="rateupload"
                                           ref="rateupload" type="file"/>
                                    <a @click="$refs.rateupload.click()" class="dropdown-item" href="javascript:void(0)"
                                       id="rateuploadbtn">
                                        <i class="fa fa-upload"/> Upload Rates
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0 bg-light">
                                    <th class="border-0"><h6>Name</h6></th>
                                    <th class="border-0"><h6>Variety</h6></th>
                                    <th class="border-0"><h6>Native Name</h6></th>
                                    <th class="border-0"><h6>Category</h6></th>
                                    <th class="border-0"><h6>Properties</h6></th>
                                    <th class="border-0"><h6>Commodity Code</h6></th>
                                    <th class="border-0"><h6>Current Rate</h6></th>
                                    <th class="border-0"><h6>Units</h6></th>
                                    <th class="border-0"><h6>Action</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(c, index) in commodities">
                                    <td>{{c.name}}</td>
                                    <td>{{c.variety}}</td>
                                    <td>{{c.native}}</td>
                                    <td>
                                        <goods-services-category :category="c.category"/>
                                    </td>
                                    <td>
                                        <ul>
                                            <li v-bind:key="index" v-for="(cp, index) in c.commodity_props">
                                                {{cp.value}}
                                            </li>
                                        </ul>
                                    </td>
                                    <td>{{c.code}}</td>
                                    <td v-if="c.rate.amount">{{c.rate | money}}</td>
                                    <td v-if="!c.rate.amount">{{'N/A' }}</td>
                                    <td>{{c.unit.symbol}}</td>
                                    <td>
                                        <a @click="viewCommodity(c.id)" href="javascript:void(0)">
                                            <h6>View & Edit</h6>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import GoodsServicesCategory from "../../express/purchases/goods-services/GoodsServicesCategory";
    import Multiselect from "vue-multiselect";
    import XLSX from "xlsx";
    import categories from "@/data/commodityCatagories";

    // const categories = [
    //     {
    //         "name": "Old",
    //         "value": "OLD"
    //     },
    //     {
    //         "name": "Service",
    //         "value": "SERVICE"
    //     },
    //     {
    //         "name": "Vegetables",
    //         "value": "VEGETABLES"
    //     },
    //     {
    //         "name": "Fruits",
    //         "value": "FRUITS"
    //     },
    //     {
    //         "name": "Dry Fruits",
    //         "value": "DRY_FRUITS"
    //     },
    //     {
    //         "name": "Food Grains",
    //         "value": "FOOD_GRAIN"
    //     },
    //     {
    //         "name": "Pulses",
    //         "value": "PULSES"
    //     },
    //     {
    //         "name": "Processed Items",
    //         "value": "PROCESSED_ITEMS"
    //     },
    //     {
    //         "name": "Spices",
    //         "value": "SPICES"
    //     },
    //     {
    //         "name": "Dairy",
    //         "value": "DAIRY"
    //     },
    //     {
    //         "name": "Edible Oils",
    //         "value": "EDIBLE_OILS"
    //     },
    //     {
    //         "name": "Salt Sugar Jaggery",
    //         "value": "SALT_SUGAR_JAGGERY"
    //     },
    //     {
    //         "name": "Beverages",
    //         "value": "BEVERAGES"
    //     },
    //     {
    //         "name": "Exotic",
    //         "value": "EXOTIC"
    //     },
    //     {
    //         "name": "Non Veg",
    //         "value": "NON_VEG"
    //     }
    // ];

    export default {
        name: "Growers",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {GoodsServicesCategory, Blockie, Paginate, Multiselect},
        data() {
            return {
                categories: [],
                commodities: [],
                pageCount: 1,
                total: 0,
                category: null,
                search: null,
                exporting: false,
                comp: '=',
                rate: null
            };
        },
        mounted() {
            this.getCommodities(1);
        },
        methods: {
            getCommodities(page) {
                $(".preloader").fadeIn();
                this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/`, {
                        params: {
                            page: page,
                            perPage: 10,
                            search: this.search,
                            category: this.category ? this.category.value : undefined,
                            comp: this.rate ? this.comp : undefined,
                            rate: this.rate ? Number(this.rate) : undefined,
                        }
                    })
                    .then(reply => {
                        $(".preloader").fadeOut();
                        this.total = reply.data.total;
                        this.commodities = reply.data.commodities;
                        this.setPageCount();
                    })
                    .catch(err => {
                        $(".preloader").fadeOut();
                        console.log(err);
                    });
            },
            pageHandler(pageNum) {
                this.getCommodities(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            viewCommodity(commodityid) {
                this.$router.push({name: "viewcommodity", params: {commodityid: commodityid}});
            },
            filterCategory(search) {
                this.categories = _.filter(categories, (c) => {
                    return c.name.indexOf(search) != -1;
                });
            },
            async reset() {
                this.search = null;
                this.rate = null;
                this.comp = '=';
                this.category = null;
                await this.getCommodities(1)
            },
            async exportGSAsExcel() {
                try {
                    this.exporting = true;
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/`, {
                            params: {
                                page: 1,
                                perPage: this.total,
                                search: this.search,
                                category: this.category ? this.category.value : undefined,
                                comp: this.rate ? this.comp : undefined,
                                rate: this.rate ? Number(this.rate) : undefined,
                            }
                        });
                    let data = reply.data.commodities;
                    let commodities = [];
                    data.forEach(d => {
                        commodities.push({
                            "ID": d.id,
                            "Name": d.name,
                            "Variety": d.variety,
                            "Native Name": d.native,
                            "Description": d.description,
                            "Category": d.category,
                            "Measuring Unit": d.unit.symbol,
                            "Currency": d.rate.currency_symbol,
                            "Rate": d.rate.amount
                        })
                    });

                    let workbook = XLSX.utils.book_new();
                    let worksheet = XLSX.utils.json_to_sheet(commodities);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Commodity');
                    XLSX.writeFile(workbook, 'Commodity.xlsx');
                } catch (e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exporting = false;
                }
            },
            async handleRateUpload() {
                try {
                    let file = this.$refs.rateupload.files[0];
                    let reader = new FileReader();
                    reader.onload = async (e) => {
                        try {
                            let data = new Uint8Array(e.target.result);
                            let workbook = XLSX.read(data, {type: 'array'});
                            let arr = XLSX.utils.sheet_to_json(workbook.Sheets["Commodity"]);

                            await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/rates`, arr);
                            this.$toastr('success', 'Rate uploaded', 'Success');
                        } catch (e) {
                            this.$toastr('error', 'Rate upload failed', 'Failure');
                            console.error(e);
                        } finally {
                            await this.$router.go();
                            // await this.$router.go(this.$router.currentRoute)
                        }
                    };
                    reader.readAsArrayBuffer(file);
                } catch (e) {
                    console.error(e)
                }
            },
        }
    }
</script>

<style scoped>
    .commodities tr {
        cursor: pointer;
    }
</style>
